import { FC } from "react";
import { useParams } from "react-router-dom";
import AnimateIn from "../../../../components/animateIn";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import PageBody from "../../../../layout/pageBody";
import PageTitle from "../../../../layout/pageTitle";
import { taxCaseUrl } from "../../../../services/taxService";
import { useApi } from "../../../../services/useApi";
import { ParamTypes, ScreenProps } from "../../../../types/appTypes";
import { initTaxCase, TaxCase } from "../../../../types/taxTypes";
import TaxCaseHeadExtra from "../taxCaseHeadExtra";
import TaxCaseEdit from "./taxCaseEdit";
import TaxCasePageTitleExtra from "./taxCasePageTitleExtra";

const TaxCaseAdmin: FC<ScreenProps> = ({ title }) => {
  const { id } = useParams<ParamTypes>();
  const [{ data, isLoading }] = useApi<TaxCase>(taxCaseUrl(id), initTaxCase, true);
  const caseReceived = data.id > 0;

  return (
    <TaxCaseStore.Provider initialState={data}>
      <PageTitle
        title={`${title}/${id}`}
        fluid
        headerMargin={false}
        backBtn
        extra={<TaxCasePageTitleExtra />}
        footer={caseReceived && <TaxCaseHeadExtra />}
      />
      <PageBody>
        <AnimateIn start={!isLoading && caseReceived} loadingBeforeStart>
          <TaxCaseEdit />
        </AnimateIn>
      </PageBody>
    </TaxCaseStore.Provider>
  );
};

export default TaxCaseAdmin;
